import useAuth from 'providers/hooks/useAuth';
import React from 'react';
import GetTheAppBanner from 'src/components/banner/GetTheAppBanner';
import SignUpBanner from 'src/components/banner/SignUpBanner';
import Layout from 'src/components/layout/Layout';
import { LayoutSection } from 'src/components/layout/Layout.types';
import { PageMetadata } from 'types/metadataTypes';
import { GAP_SIZE_REM } from 'utils/global';

export interface PublicPagesContainerProps {
  children: React.ReactNode;
  pageMetadata: PageMetadata;
}

const PublicPagesContainer: React.FC<PublicPagesContainerProps> = ({
  children,
  pageMetadata,
}) => {
  const { isLoggedIn } = useAuth();

  const metaContent = !isLoggedIn ? (
    <SignUpBanner size="sm" mb={{ base: GAP_SIZE_REM, md: 0 }} />
  ) : (
    <GetTheAppBanner />
  );

  const mainLayoutSection: LayoutSection = {
    content: children,
    metaContent: metaContent,
    metaContentTopOffset: 0,
  };

  return <Layout pageMetadata={pageMetadata} sections={[mainLayoutSection]} />;
};

export default PublicPagesContainer;
